export enum TipoCrc {
    Originario = 1,
    Filial = 2,
    Provisorio = 3
}
